exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".import-order-action[data-v-3992d6d0]{margin-right:10px;vertical-align:middle}.import-order-action[data-v-3992d6d0],.import-order-tip[data-v-3992d6d0]{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center}.import-order-tip[data-v-3992d6d0]{-ms-flex-pack:center;justify-content:center;width:16px;height:16px;margin-left:8px;color:#606266;cursor:pointer;font-size:15px;transition:color .2s}.import-order-tip[data-v-3992d6d0]:hover{color:#409eff}.import-order-tip-content[data-v-3992d6d0]{line-height:22px;max-width:360px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3992d6d0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/customer/importOrder.vue
// module id = 2261
// module chunks = 0